import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IQuestionnaireResponse } from "@comunicare/comunicare-interfaces";
import moment from "moment";

export class QRDataSource extends MatTableDataSourceExtended<IQuestionnaireResponse> {
  override sortingDataAccessor = (data: IQuestionnaireResponse, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "modified":
        return moment(data.modified).unix();
      case "questionnaire":
        return data.questionnaire.display;
      case "user":
        return data.subject.reference;
      default:
        return "";
    }
  };

  public loadData(data: IQuestionnaireResponse[]): void {
    this.data = data;
  }
}
